import { agentLabel, isAttemptLimit } from './format';

const timestamp = value => value ? Date.parse(value) : NaN;
const oneLine = value => (value || '').replace(/\s+/g, ' ').trim();

export function sessionActivity(tasks = [], goals = [], artifacts = []) {
  const counts = { running: 0, done: 0, queued: 0, failed: 0 };
  const events = [];
  const addEvent = (id, at, text) => {
    if (Number.isFinite(timestamp(at))) events.push({ id, at, text });
  };
  for (const task of tasks) {
    const attemptLimit = isAttemptLimit(task.last_error);
    if (['running', 'waiting_tool'].includes(task.status)) counts.running += 1;
    if (task.status === 'done') counts.done += 1;
    if (task.status === 'todo') counts.queued += 1;
    if (task.status === 'failed' && !attemptLimit) counts.failed += 1;
    const subject = `${agentLabel(task.assigned_to)} — ${oneLine(task.objective)}`;
    addEvent(`queued:${task.id}`, task.created_at, `Добавлена задача: ${subject}`);
    addEvent(`started:${task.id}`, task.started_at, `Начата задача: ${subject}`);
    if (task.status === 'done') addEvent(`done:${task.id}`, task.finished_at, `Завершена задача: ${subject}`);
    if (task.status === 'failed') {
      const label = attemptLimit ? task.last_error : 'Ошибка задачи';
      addEvent(`failed:${task.id}`, task.finished_at, `${label}: ${subject}`);
    }
  }
  for (const artifact of artifacts) {
    if (['user_prompt', 'human_answer', 'assistant_message'].includes(artifact.artifact_type)) continue;
    addEvent(`artifact:${artifact.id}`, artifact.created_at, `Сохранён материал: ${oneLine(artifact.title)}`);
  }
  for (const goal of goals) {
    for (const review of goal.reviews || []) {
      addEvent(`review:${review.id}`, review.created_at,
        `${review.accepted ? 'Принят результат' : 'Результат отправлен на доработку'}: ${oneLine(goal.objective)}`);
    }
  }
  events.sort((a, b) => timestamp(b.at) - timestamp(a.at));
  const active = tasks.filter(task => ['running', 'waiting_tool'].includes(task.status))
    .sort((a, b) => (timestamp(b.started_at) || 0) - (timestamp(a.started_at) || 0))
    .map(task => {
      const goal = goals.find(item => task.goal_id ? item.id === task.goal_id : item.source_task_id === task.id);
      const hasChildren = tasks.some(item => item.parent_task_id === task.id && ['todo', 'running', 'waiting_tool'].includes(item.status));
      const phase = task.status === 'waiting_tool' ? 'Ожидает инструмент'
        : goal?.status === 'review' ? 'Проверка результата'
        : hasChildren ? 'Координация подзадач'
        : task.assigned_to === 'source_verifier' ? 'Проверка источников' : 'Выполнение задачи';
      return { ...task, phase };
    });
  return { counts, active, events: events.slice(0, 5), latest: events[0] || null };
}

export function activityAge(value, now = Date.now()) {
  const at = timestamp(value);
  if (!Number.isFinite(at)) return 'время неизвестно';
  const seconds = Math.max(0, Math.floor((now - at) / 1000));
  if (seconds < 10) return 'только что';
  if (seconds < 60) return `${seconds} с назад`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} мин назад`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} ч назад`;
  return `${Math.floor(seconds / 86400)} дн назад`;
}
